import React, { createContext, useContext, useState, useEffect } from 'react';
import { getLocale, detectLocale, LOCALES } from '../lib/locale';

const LocaleContext = createContext(null);

export function LocaleProvider({ children, initial_country }) {
  const [countryCode, setCountryCode] = useState(initial_country || null);
  const [locale, setLocale] = useState(getLocale(initial_country));
  
  useEffect(() => {
    if (initial_country) {
      setLocale(getLocale(initial_country));
      setCountryCode(initial_country);
      return;
    }
    
    const saved = typeof window !== 'undefined' 
      ? window.localStorage?.getItem('pluginany_country') 
      : null;
    
    if (saved && LOCALES[saved]) {
      setLocale(getLocale(saved));
      setCountryCode(saved);
      return;
    }
    
    const browserLang = typeof window !== 'undefined' ? window.navigator?.language : null;
    const detected = detectLocale({ browser_language: browserLang });
    setLocale(detected);
    setCountryCode(detected.country_code);
  }, [initial_country]);
  
  function changeCountry(newCountryCode) {
    if (!LOCALES[newCountryCode]) return;
    setCountryCode(newCountryCode);
    setLocale(getLocale(newCountryCode));
    if (typeof window !== 'undefined') {
      window.localStorage?.setItem('pluginany_country', newCountryCode);
    }
  }
  
  const value = {
    locale,
    countryCode,
    changeCountry,
    availableCountries: Object.keys(LOCALES),
  };
  
  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    throw new Error('useLocale must be used inside a LocaleProvider');
  }
  return ctx;
}
